var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrapper"}},[_c('h3',{staticClass:"more"},[_vm._v("Alte comunicate:")]),_vm._l((_vm.items),function(item){return _c('div',{key:item.id,staticClass:"press-release-link",class:{ active: _vm.$route.params.subsection === item.slug }},[_c('router-link',{attrs:{"to":{
        name: 'media-subsection',
        params: {
          section: 'press',
          subsection: item.slug,
          locale: _vm.$i18n.locale
        }
      }},nativeOn:{"click":function($event){return _vm.$emit('scrollToTop')}}},[_vm._v(" "+_vm._s(item.title)+" ")])],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }